import { StreamMessage } from 'utils/messages/StreamMessage';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useWidgetComponentState } from 'widgets/store/component/selectors';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { useWidgetMessages } from 'widgets/store/stream/selectors';
import { usePortfolioActiveInputUsesOrdersStream } from 'portfolio/store/hooks';

export interface WidgetStateWithRequestSymbology {
    requestSymbology?: string;
}

export const useWidgetMessagesAdornedWithSymbologyWarning: () => StreamMessage[] =
    () => {
        const { widgetKey, widgetType } = useWidgetContext();
        const messages = [...useWidgetMessages()];
        const componentState =
            useWidgetComponentState<WidgetStateWithRequestSymbology>(
                widgetType,
                widgetKey
            );
        const { symbology } = useSelectAppSettings();
        const usingOrders = usePortfolioActiveInputUsesOrdersStream();

        if (!usingOrders) {
            return messages;
        }

        const message = `Instinet symbols were used as your orders do not have ${symbology} symbols`;
        if (
            componentState?.requestSymbology === SymbologyValues.Instinet &&
            symbology !== SymbologyValues.Instinet &&
            messages[0]?.message !== message
        ) {
            messages.unshift({
                message,
            });
        }

        return messages;
    };
